<div _ngcontent-c0="" class="app-content ui basic segment container">
  <div _ngcontent-c3="" class="ui basic segment wrapper">

    <div class="full-width ui basic segment">

      <!-- <app-breadcrumb></app-breadcrumb> -->

      <h1 class="ui block header">
        The Commission's Policy On Payments Made By Customers
      </h1>

      <div class="ui basic segment">
        <p>
          Where a customer is unable to use up any payment, it shall be refunded or the payment can be applied on
          another future transaction.
        </p>
      </div>


    </div>
  </div>
</div>
